<span class="select-label">
    <i nz-icon nzType="global" style="margin-right: 2px;"></i>
    Language:
</span>
<nz-select
  [(ngModel)]="selectedLanguageCode"
  (ngModelChange)="onLanguageChange($event)"
  nzPlaceHolder="Select Language"
  nzSize="default"
  style="width: 200px;">

  @for (lang of languages(); track lang) {
    <nz-option
      [nzValue]="lang.code"
      [nzLabel]="lang.name">
        <span>
          {{ lang.name }}
        </span>
    </nz-option>
  }

</nz-select>
